import { ContactUsForm } from 'components/commercetools-ui/static-page-forms/contact-form';

export const ContactUSFormTastics = (props) => {
  const { data } = props;
  return <ContactUsForm data={data} isCorporateForm={false} />;
};
